var map = {
	"./JNTRB_jointer_smartswap.png": 526,
	"./arrow-down-blue.svg": 527,
	"./arrow-down-grey.svg": 528,
	"./arrow-right-white.png": 529,
	"./arrow-right.svg": 530,
	"./bg01.jpg": 531,
	"./bg02.png": 532,
	"./binance-logo.png": 533,
	"./blue-loader.svg": 193,
	"./bnb.svg": 534,
	"./bnbICON.png": 535,
	"./bsc-icon.png": 256,
	"./bscLogo-black.png": 536,
	"./bscLogo.png": 537,
	"./burp-sIcon-01.png": 538,
	"./burp-sIcon-010.png": 539,
	"./burp-sIcon-02.png": 540,
	"./burp-sIcon-03.png": 541,
	"./burp-sIcon-04.png": 542,
	"./burp-sIcon-05.png": 543,
	"./burp-sIcon-06.png": 544,
	"./burp-sIcon-07.png": 545,
	"./burp-sIcon-08.png": 546,
	"./burp-sIcon-09.png": 547,
	"./checkmark.svg": 548,
	"./circle-grey.svg": 549,
	"./circle.svg": 550,
	"./close-backBTN-02.png": 551,
	"./close-backBTN.png": 552,
	"./close-btn.png": 182,
	"./close-btn2.png": 122,
	"./closeBTN.png": 553,
	"./coinIco-01.png": 554,
	"./coinIco-02.png": 555,
	"./coinIco-03.png": 556,
	"./coinIco-04.png": 557,
	"./coinIco-05.png": 558,
	"./coinIco-06.png": 559,
	"./coinIco-07.png": 560,
	"./coinIco-08.png": 561,
	"./coinIco-09.png": 562,
	"./coinbaseWalletIcon.svg": 563,
	"./darkBG-old.png": 564,
	"./darkBG.png": 257,
	"./darkBG01.png": 565,
	"./dd-menu-Icon-01.png": 566,
	"./dd-menu-Icon-02.png": 567,
	"./dd-menu-Icon-03.png": 568,
	"./dd-menu-Icon-04.png": 569,
	"./ddI-ICON-01.png": 570,
	"./ddI-ICON-02.png": 571,
	"./ddI-ICON-03.png": 572,
	"./ddIcon-01-dark.png": 573,
	"./ddIcon-01.png": 574,
	"./ddIcon-02-dark.png": 575,
	"./ddIcon-02.png": 576,
	"./ddIcon-03-dark.png": 577,
	"./ddIcon-03.png": 578,
	"./ddIcon-04-dark.png": 579,
	"./ddIcon-04.png": 580,
	"./ddIcon-05-dark.png": 581,
	"./ddIcon-05.png": 582,
	"./ddIcon-06-dark.png": 583,
	"./ddIcon-06.png": 584,
	"./default.png": 158,
	"./dexIcon-01.png": 258,
	"./dexIcon-010.png": 259,
	"./dexIcon-011.png": 260,
	"./dexIcon-012.png": 261,
	"./dexIcon-013.png": 262,
	"./dexIcon-014.png": 263,
	"./dexIcon-015.png": 264,
	"./dexIcon-016.png": 265,
	"./dexIcon-017.png": 266,
	"./dexIcon-018.png": 267,
	"./dexIcon-019.png": 268,
	"./dexIcon-02.png": 269,
	"./dexIcon-020.png": 270,
	"./dexIcon-021.png": 271,
	"./dexIcon-022.png": 272,
	"./dexIcon-023.png": 273,
	"./dexIcon-024.png": 274,
	"./dexIcon-025.png": 275,
	"./dexIcon-026.png": 276,
	"./dexIcon-027.png": 277,
	"./dexIcon-028.png": 278,
	"./dexIcon-029.png": 279,
	"./dexIcon-03.png": 280,
	"./dexIcon-030.png": 281,
	"./dexIcon-031.png": 282,
	"./dexIcon-032.png": 283,
	"./dexIcon-033.png": 284,
	"./dexIcon-034.png": 285,
	"./dexIcon-035.png": 286,
	"./dexIcon-036.png": 287,
	"./dexIcon-037.png": 288,
	"./dexIcon-038.png": 289,
	"./dexIcon-039.png": 290,
	"./dexIcon-04.png": 291,
	"./dexIcon-040.png": 292,
	"./dexIcon-041.png": 293,
	"./dexIcon-05.png": 294,
	"./dexIcon-06.png": 295,
	"./dexIcon-07.png": 296,
	"./dexIcon-08.png": 297,
	"./dexIcon-09.png": 298,
	"./dollar_icon.png": 585,
	"./dropdown-blue.svg": 586,
	"./dropdown.svg": 587,
	"./dropup-blue.svg": 588,
	"./ethICON.png": 589,
	"./etherLOGO.png": 590,
	"./farmSIcon01.png": 591,
	"./farmSIcon02.png": 592,
	"./farmSIcon03.png": 593,
	"./farmSIcon04.png": 594,
	"./favicon.png": 595,
	"./fighter-icon.png": 299,
	"./fire.gif": 300,
	"./fire.png": 596,
	"./footerLink_icon.png": 301,
	"./fortmaticIcon.png": 597,
	"./greenDot.png": 598,
	"./heart_icon.png": 599,
	"./ifo-icon00.png": 600,
	"./ifo-icon01.png": 601,
	"./ifo-icon010.png": 602,
	"./ifo-icon011.png": 603,
	"./ifo-icon02.png": 604,
	"./ifo-icon03.png": 605,
	"./ifo-icon04.png": 606,
	"./ifo-icon05.png": 607,
	"./ifo-icon07-1.png": 608,
	"./ifo-icon07.png": 609,
	"./ifo-icon08.png": 610,
	"./ifo-icon09.png": 611,
	"./jackpot.png": 302,
	"./jntrnote-icon.png": 612,
	"./jointer-logo.png": 613,
	"./link.svg": 614,
	"./logo.png": 615,
	"./logo_white.png": 616,
	"./magnifying-glass.svg": 617,
	"./mathwallet.svg": 303,
	"./menu.svg": 618,
	"./metamask.png": 304,
	"./network/arbitrum.png": 355,
	"./network/bsc.png": 356,
	"./network/bsc.svg": 357,
	"./network/matic.png": 358,
	"./network/matic.svg": 359,
	"./network/rsz_arbitrum.webp": 360,
	"./odoMeterbg-light.png": 619,
	"./odoMeterbg.png": 620,
	"./otum-logo.png": 305,
	"./pancake-logo.png": 244,
	"./pdo-logo.png": 123,
	"./pdo.png": 306,
	"./plus-blue.svg": 621,
	"./plus-grey.svg": 622,
	"./portisIcon.png": 623,
	"./qrIcon.png": 624,
	"./question-mark.svg": 625,
	"./question.svg": 626,
	"./qwantum.png": 307,
	"./serviceBg01.jpg": 627,
	"./shildMark.png": 628,
	"./sliderICO-01.png": 629,
	"./sliderICO-02.png": 308,
	"./sliderICO-03.png": 630,
	"./sliderICO-04.png": 631,
	"./sliderICO-05.png": 632,
	"./sliderICO-06.png": 633,
	"./spinner.svg": 634,
	"./sprite.png": 635,
	"./sushiswap-logo.png": 246,
	"./textbox-icon.png": 636,
	"./timerBGBack.png": 309,
	"./trophy_icon.png": 310,
	"./trustWallet.png": 637,
	"./trustwallet.svg": 311,
	"./uniswap-logo.png": 245,
	"./walletConnectIcon.svg": 255,
	"./x.svg": 638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;